import { CONTACT } from "../data/site";
import { Reveal, MaskedLine } from "../components/Reveal";
import { Seo } from "../components/Seo";

const sections = [
  {
    title: "Responsable du traitement",
    content: [
      `Le responsable du traitement des données collectées sur ce site est ${CONTACT.fullName}, ${CONTACT.address} — SIREN ${CONTACT.siren}.`,
      `Contact dédié à la protection des données : ${CONTACT.privacy} — ${CONTACT.phone}.`,
    ],
  },
  {
    title: "Données collectées",
    content: [
      "Via le formulaire de demande de renseignement : nom, adresse email, numéro de téléphone (facultatif), studio concerné, dates de séjour souhaitées (facultatives) et contenu de votre message.",
      "Aucune donnée bancaire n'est collectée sur ce site. Aucun compte utilisateur n'est créé.",
    ],
  },
  {
    title: "Finalités et base légale",
    content: [
      "Vos données sont utilisées exclusivement pour répondre à votre demande de renseignement et, le cas échéant, préparer et gérer votre réservation.",
      "Ces traitements reposent sur l'exécution de mesures précontractuelles et contractuelles (article 6.1.b du RGPD). Vos données ne sont jamais utilisées à des fins publicitaires sans votre consentement explicite.",
    ],
  },
  {
    title: "Destinataires des données",
    content: [
      "Vos données sont destinées uniquement à la SAS Vaucopin. Elles ne sont ni vendues, ni cédées, ni partagées avec des tiers à des fins commerciales.",
      "L'envoi des emails de notification transite par un prestataire technique d'envoi d'emails, agissant comme sous-traitant dans le strict cadre de cette mission.",
    ],
  },
  {
    title: "Durée de conservation",
    content: [
      "Les demandes de renseignement sans suite sont conservées au maximum 3 ans à compter de notre dernier échange.",
      "Les données liées à une réservation sont conservées pendant les durées légales applicables en matière comptable et fiscale.",
    ],
  },
  {
    title: "Vos droits",
    content: [
      "Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données.",
      `Pour exercer ces droits, écrivez à ${CONTACT.privacy} en précisant votre demande. Une preuve d'identité pourra vous être demandée.`,
      "Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).",
    ],
  },
  {
    title: "Cookies et traceurs",
    content: [
      "Ce site n'utilise aucun cookie publicitaire ni de suivi marketing.",
      "Votre choix de langue est mémorisé localement sur votre appareil (stockage local du navigateur) pour votre confort de navigation. Un outil de mesure d'audience et d'analyse technique fourni par la plateforme d'hébergement peut déposer des traceurs strictement techniques.",
    ],
  },
  {
    title: "Sécurité",
    content: [
      "Les échanges avec ce site sont chiffrés (HTTPS). Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès, perte ou divulgation non autorisés.",
    ],
  },
  {
    title: "Modifications de la présente politique",
    content: [
      "Cette politique de confidentialité peut être mise à jour. La version en vigueur est celle publiée sur cette page. Dernière mise à jour : octobre 2026.",
    ],
  },
];

export default function PolitiqueConfidentialite() {
  return (
    <div data-testid="privacy-page" className="pt-40 pb-24 md:pb-32">
      <Seo titleKey="seo.privacy.title" descKey="seo.privacy.description" />
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <p className="text-xs uppercase tracking-[0.25em] text-pine-light font-semibold mb-6">Protection de vos données</p>
        <h1 className="font-serif text-4xl sm:text-6xl tracking-tighter text-pine leading-[0.95]">
          <MaskedLine delay={0.1}>Politique de confidentialité</MaskedLine>
        </h1>
        <Reveal>
          <p className="mt-8 text-ink/70 leading-relaxed max-w-2xl">
            Cette page explique quelles données sont collectées lors de votre visite, pourquoi, combien de temps elles sont conservées et comment exercer vos droits.
          </p>
        </Reveal>

        <div className="mt-16 space-y-16">
          {sections.map((s, i) => (
            <Reveal key={s.title} delay={0.05}>
              <section data-testid={`privacy-section-${i}`} className="border-t border-pine/15 pt-8">
                <h2 className="font-serif text-2xl md:text-3xl text-pine tracking-tight">
                  <span className="text-wood-dark mr-4">0{i + 1}.</span>
                  {s.title}
                </h2>
                <div className="mt-6 space-y-4">
                  {s.content.map((p) => (
                    <p key={p.slice(0, 30)} className="text-ink/70 leading-relaxed">{p}</p>
                  ))}
                </div>
              </section>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
